import api from '../utils/api';

// Fetch all fees
export const getFees = async (headers) => {
  try {
    const response = await api.get('/api/fees', headers);
    console.log("all fees", response.data)
    return response.data;
  } catch (error) {
    console.error('Error fetching fees:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific fee by ID
export const getFeeById = async (id, headers) => {
  try {
    const response = await api.get(`/api/fees/${id}`, headers);
    console.log("get one fee ", response.data);
    return response.data;
  } catch (error) {
    console.error(`Error fetching fee with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new fee
export const createFee = async (feeData, headers) => {
  try {
    const response = await api.post('/api/fees', feeData, headers);
    return response.data;
  } catch (error) {
    console.error('Error creating fee:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing fee
export const updateFee = async (id, feeData, headers) => {
  try {
    const response = await api.put(`/api/fees/${id}`, feeData, headers);
    return response.data;
  } catch (error) {
    console.error(`Error updating fee with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a fee
export const deleteFee = async (id, headers) => {
  try {
    const response = await api.delete(`/api/fees/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error deleting fee with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};
